//src/pages/PrivacyPolicyPage.js
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import AddedToBagToast from "../components/AddedToBagToast";
import { LanguageContext } from "../context/LanguageContext";
import { getPrivacyPolicySettings } from "../services/homepage.api";

function PrivacyPolicyPage() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
const [loading, setLoading] = useState(true);

  useEffect(() => {
  let mounted = true;

  setLoading(true);

  getPrivacyPolicySettings()
    .then((data) => {
      if (mounted) setSettings(data);
    })
    .catch(() => {
      if (mounted) setSettings(null);
    })
    .finally(() => {
      if (mounted) setLoading(false);
    });

  return () => {
    mounted = false;
  };
}, []);

  const title =
    lang === "AR"
      ? settings?.title_ar || "سياسة الخصوصية"
      : settings?.title_en || "Privacy Policy";

  const content =
    lang === "AR"
      ? settings?.content_ar || ""
      : settings?.content_en || "";

      const safeContent =
  content.trim() ||
  (lang === "AR"
    ? "لم يتم إضافة محتوى سياسة الخصوصية بعد."
    : "Privacy policy content has not been added yet.");

    if (loading) {
  return (
    <div className="w-full min-h-screen bg-[#F6EFE9] flex flex-col">
      <TopBanner />
      <MainHeader />

      <CartDrawer />
      <AddedToBagToast />

      <main
        dir={lang === "AR" ? "rtl" : "ltr"}
        className="w-full px-5 md:px-10 pt-8 md:pt-[170px] pb-12"
      >
        <div className="max-w-5xl mx-auto">
          <div className="h-4 w-[260px] bg-gray-200 animate-pulse rounded mb-10" />
          <div className="h-9 w-[300px] bg-gray-200 animate-pulse rounded mb-3" />
          <div className="h-px bg-gray-200 mb-8" />

          <div className="space-y-4">
            <div className="h-5 w-full bg-gray-200 animate-pulse rounded" />
            <div className="h-5 w-[94%] bg-gray-200 animate-pulse rounded" />
            <div className="h-5 w-[88%] bg-gray-200 animate-pulse rounded" />
            <div className="h-5 w-[76%] bg-gray-200 animate-pulse rounded" />
            <div className="h-5 w-[92%] bg-gray-200 animate-pulse rounded" />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

  return (
    <div className="w-full min-h-screen bg-[#F6EFE9] flex flex-col">
      <TopBanner />
      <MainHeader />

      <CartDrawer />
      <AddedToBagToast />

      <main
        dir={lang === "AR" ? "rtl" : "ltr"}
        className="w-full px-5 md:px-10 pt-8 md:pt-[170px] pb-12"
      >
        <div className="max-w-5xl mx-auto">
          <div className="text-[14px] text-gray-500 mb-10">
  <button
    type="button"
    onClick={() => {
      navigate("/");
      setTimeout(() => window.scrollTo({ top: 0, left: 0 }), 0);
    }}
    className="hover:text-black hover:underline transition"
  >
    {lang === "AR" ? "الرئيسية" : "Main page"}
  </button>

  <span className="mx-2">›</span>
  CHIACA
  <span className="mx-2">›</span>
  {title}
</div>

          <h1 className="text-[24px] md:text-[34px] font-semibold text-black mb-3">
            {title}
          </h1>

          <div className="h-px bg-gray-300 mb-8" />

          <div className="prose prose-sm md:prose-base max-w-none">
            <div className="whitespace-pre-line text-[16px] md:text-[18px] leading-8 text-gray-800">
              {safeContent}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;